import script from "./InviteTeams.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteTeams.vue?vue&type=script&setup=true&lang=js"

import "./InviteTeams.vue?vue&type=style&index=0&id=b5c00e3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5c00e3e"]])

export default __exports__